import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AUTH_CONFIG } from '@/lib/constants/config';
import { type UserRole } from '@/types';
import { ROUTES } from '@/lib/constants/routes';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { useAuthStore } from '@/store/authStore';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading, clearAuth } = useAuthStore();
    const location = useLocation();

    // Verify token consistency on mount and when auth state changes
    useEffect(() => {
        const token = localStorage.getItem(AUTH_CONFIG.TOKEN_KEY);
        if (isAuthenticated && !token) {
            clearAuth();
        }
    }, [isAuthenticated, clearAuth]);

    // if (isLoading) {
    //     return (
    //         <div className="flex h-screen items-center justify-center">
    //             <LoadingSpinner size="lg" />
    //         </div>
    //     );
    // }

    if (!isAuthenticated) {
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
    }

    // if (allowedRoles && user && !allowedRoles.includes(user?.roles)) {
    //     return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
    // }

    return <>{children}</>;
}